import { jsx as _jsx } from "react/jsx-runtime";
export const BuyAdditionalCreditsCard = () => {
  return /*#__PURE__*/_jsx("div", {
    children: "BuyAdditionalCreditsCard"
  });
};